import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=9a5c856e&scoped=true&"
import script from "./sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./sidebar.scss?vue&type=style&index=0&id=9a5c856e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5c856e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a5c856e')) {
      api.createRecord('9a5c856e', component.options)
    } else {
      api.reload('9a5c856e', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=9a5c856e&scoped=true&", function () {
      api.rerender('9a5c856e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/sidebar.vue"
export default component.exports